module.exports = __webpack_public_path__ + "img/96.9.TU.5843afdd.png";